import { Text } from '@breville/xps-react/dist/Text/Text'
import { Tag } from '@breville/xps-react/dist/Tag/Tag'
import { RecipeCard } from '@breville/xps-react/dist/RecipeCard/RecipeCard'

function RecipeCardComp (props:any) {
  const {src,author,title,href,
      titleType = 'h4',
      titleTag = 'label',
      tagBg = 'white',
      tagTextColor = 'accent',
      altText = 'ChefSteps'
    } = props
    return (      
      <RecipeCard
        altText={altText}
        href={href}
        image={src}
        nativeImage
      >
        <RecipeCard.Title>
          <Text type={titleType} tag={titleTag}>
            {title}
          </Text>
        </RecipeCard.Title>
        <RecipeCard.Footer>
          <Tag
            tagBg={tagBg}
            tagText={author}
            tagTextColor={tagTextColor}
          />
        </RecipeCard.Footer>
      </RecipeCard>
    )
}

export default RecipeCardComp